import React from "react";
import Nav from "../containers/Nav";
import PatientContainer from "../containers/PatientContainer";
import {useTranslation} from "react-i18next";

const Patient = () => {
    const {t} = useTranslation()
    return (
        <div className="App">
            <Nav/>
            <PatientContainer/>
        </div>
    );
}
export default Patient;